import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors, namedBreakpoints } from 'theme';

export const CmsTileModalCloseButtonStyled = styled.button`
  height: 41px;
  color: ${colors.battleshipGrey};
  background-color: transparent;
  border-radius: 0;
  display: flex;
  align-items: center;

  &:hover:not(:disabled) {
    color: ${colors.waterBlue};
  }
`;

export const CmsTileModalCloseButtonText = styled.span`
  height: 18px;
  margin-right: 8px;
  display: block;

  @media (max-width: ${namedBreakpoints.xsDown}) {
    /* block-no-empty */
    ${visuallyHiddenCss}
  }
`;
